import { ColumnConfig } from '@/components/table/Table';
import { appUrl } from '@/utils/appUrl';

export const discrepancyColumns: ColumnConfig[] = [
  {
    label: 'ID Pedido',
    field: 'number',
    render: (value: number) => (
      <a
        href={appUrl(`/business/shipping/${value}`)}
        target='_blank'
        rel='noopener noreferrer'
        className='text-blue-600 hover:text-blue-800 font-bold hover:underline transition-colors'
      >
        {value}
      </a>
    ),
  },
  {
    label: 'ID Externo',
    field: 'commerceShippingNumber',
    render: (value: string) => <span>{value || '-'}</span>,
  },
  {
    label: 'Comercio',
    field: 'commerceName',
    render: (value: string) => <span>{value || '-'}</span>,
  },
  {
    label: 'Destinatario',
    field: 'recipient',
    render: (value: string) => <span>{value || '-'}</span>,
  },
  {
    label: 'Dirección',
    field: 'address',
    render: (value: string) => <span>{value || '-'}</span>,
  },
];
